<template>
  <div class='asignIcon'>
    <svg fill="#CCCCCC" width="20px" height="20px" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="m77.27 29.57a1.49 1.49 0 0 0 -1-.45 1.33 1.33 0 0 0 -1 .45l-1.27 1.2a.43.43 0 0 0 0 .55l3.13 3.13a.52.52 0 0 0 .29.09.35.35 0 0 0 .25-.09l1.21-1.21a1.42 1.42 0 0 0 -.06-2.11z"/>
        <path d="m73.05 32.34a.52.52 0 0 0 -.29-.09.35.35 0 0 0 -.25.09l-12.51 12.44-1.2 4.15a.57.57 0 0 0 .52.75h.14l4.16-1.21 12.5-12.47a.38.38 0 0 0 0-.49z"/>
        <path d="m78.24 38.14-5.58 5.56v19.18a2 2 0 0 1 -2 2h-42a2 2 0 0 1 -2-2v-23a2 2 0 0 1 2-2h34l6-6h-42a6 6 0 0 0 -6 6v27a6 6 0 0 0 6 6h46a6 6 0 0 0 6-6v-27c0-.08 0-.16 0-.24a2.8 2.8 0 0 1 -.42.5z"/>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'asignIcon'
}
</script>

<style scoped>
.asignIcon {
}
</style>
